export enum LocationTypeCode {
  VirtualWard = 'location.type.virtualward',
  VirtualHospital = 'location.type.virtualhospital',
}

export const LocationCodeDescription: Record<LocationTypeCode, string> = {
  [LocationTypeCode.VirtualHospital]: 'Virtual Hospital',
  [LocationTypeCode.VirtualWard]: 'Virtual Ward',
};

export enum LocationAcuityCode {
  Intensive = 'location.acuity.intensive',
  Medium = 'location.acuity.medium',
  Low = 'location.acuity.low',
  Unallocated = 'location.acuity.unallocated',
}

export const LocationAcuityDescription: Record<LocationAcuityCode, string> = {
  [LocationAcuityCode.Intensive]: 'Intensive Monitoring Ward',
  [LocationAcuityCode.Medium]: 'Medium Monitoring Ward',
  [LocationAcuityCode.Low]: 'Low Monitoring Ward',
  [LocationAcuityCode.Unallocated]: 'Classification for Unallocated Patients',
};

export const LocationAcuityLabel: Record<LocationAcuityCode, string> = {
  [LocationAcuityCode.Intensive]: 'Intensive',
  [LocationAcuityCode.Medium]: 'Medium',
  [LocationAcuityCode.Low]: 'Low',
  [LocationAcuityCode.Unallocated]: 'Unallocated',
};
